import  React from 'react'

const SectionWrapper = ({children, sectionStyles}) =>(
    <div className={`position-relative py-lg-2 ${sectionStyles}`}>
        {children}
    </div>
)
export default  SectionWrapper
    